<template>
  <div class="server-monitor">
    <v-container>
      <v-layout row wrap>
        <v-flex xs10>
          <h1 class="display-2 mb-4" style="color: #7e2985;">
            <v-icon large color="#7e2985">computer</v-icon>
            Monitor do Servidor
          </h1>
        </v-flex>
        <v-flex xs2 class="text-xs-right">
          <v-btn
            color="#7e2985"
            dark
            @click="logout"
            class="logout-button"
            elevation="3"
          >
            <v-icon left>exit_to_app</v-icon>
            Sair
          </v-btn>
        </v-flex>
      </v-layout>

      <!-- Loading -->
      <!-- <v-layout row wrap v-if="loading" justify-center>
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular
            indeterminate
            color="#7e2985"
            :size="70"
            :width="7"
          ></v-progress-circular>
          <p class="mt-4">Carregando informações do servidor...</p>
        </v-flex>
      </v-layout> -->

      <!-- Erro -->
      <v-layout row wrap v-if="error && !loading">
        <v-flex xs12>
          <v-alert type="error" :value="true">
            {{ errorMessage }}
          </v-alert>
          <v-btn color="#7e2985" dark @click="fetchServerStatus">
            <v-icon left>refresh</v-icon>
            Tentar Novamente
          </v-btn>
        </v-flex>
      </v-layout>

      <div v-if="!error">
        <!-- Informações do Servidor -->
        <v-layout row wrap>
          <v-flex xs12>
            <v-card class="pa-3 ma-2" elevation="3">
              <v-card-title class="title pb-2" style="color: #7e2985;">
                <v-icon left color="#7e2985">info</v-icon>
                Informações do Servidor
              </v-card-title>
              <v-card-text>
                <v-list v-if="serverStatus.hostname">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md3>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title class="font-weight-bold">Hostname:</v-list-tile-title>
                          <v-list-tile-sub-title>{{ serverStatus.hostname || 'N/A' }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title class="font-weight-bold">Plataforma:</v-list-tile-title>
                          <v-list-tile-sub-title>{{ serverStatus.platform || 'N/A' }} ({{ serverStatus.arch || 'N/A' }})</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title class="font-weight-bold">Sistema:</v-list-tile-title>
                          <v-list-tile-sub-title>{{ serverStatus.type || 'N/A' }} {{ serverStatus.release || '' }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title class="font-weight-bold">Uptime:</v-list-tile-title>
                          <v-list-tile-sub-title>{{ serverStatus.uptime ? serverStatus.uptime.formatted : '0d 0h 0m 0s' }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-flex>
                  </v-layout>
                </v-list>
                <div v-else class="text-xs-center pa-3">
                  <div class="subheading grey--text">Carregando...</div>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- Abas -->
        <v-layout row wrap class="mt-3">
          <v-flex xs12>
            <v-card class="pa-0 ma-2 elevation-8 custom-tabs-card">
              <v-tabs 
                v-model="activeTab" 
                color="#7e2985" 
                slider-color="#7e2985"
                class="custom-tabs"
                centered
                grow
              >
                <v-tab class="custom-tab">
                  <div class="tab-content">
                    <v-icon size="24" class="tab-icon" color="white">memory</v-icon>
                    <span class="tab-text">Processamento</span>
                  </div>
                </v-tab>
                <v-tab class="custom-tab">
                  <div class="tab-content">
                    <v-icon size="24" class="tab-icon" color="white">settings_ethernet</v-icon>
                    <span class="tab-text">Rede</span>
                  </div>
                </v-tab>
                <v-tab class="custom-tab">
                  <div class="tab-content">
                    <v-icon size="24" class="tab-icon" color="white">settings</v-icon>
                    <span class="tab-text">PM2</span>
                  </div>
                </v-tab>
                <v-tab class="custom-tab">
                  <div class="tab-content">
                    <v-icon size="24" class="tab-icon" color="white">api</v-icon>
                    <span class="tab-text">Endpoint</span>
                  </div>
                </v-tab>

                <!-- Aba 1: Processamento -->
                <v-tab-item>
                  <v-card flat class="pa-3">

        <!-- Segunda Linha: CPU e Memória -->
        <v-layout row wrap class="mt-3">
          <v-flex xs12 md6>
            <v-card class="pa-3 ma-2" elevation="3">
              <v-card-title class="title pb-2" style="color: #7e2985;">
                <v-icon left color="#7e2985">memory</v-icon>
                CPU
              </v-card-title>
              <v-card-text>
                <div v-if="serverStatus.cpu">
                  <!-- Uso da CPU -->
                  <div class="text-xs-center mb-2">
                    <div class="display-2 font-weight-bold" :style="{ color: getCpuColor(serverStatus.cpu.usage || 0) }">
                      {{ serverStatus.cpu.usage ? serverStatus.cpu.usage.toFixed(1) : '0.0' }}%
                    </div>
                    <div class="body-2 grey--text">Uso da CPU</div>
                  </div>
                  <v-progress-linear
                    :value="serverStatus.cpu.usage || 0"
                    height="25"
                    :color="getCpuColor(serverStatus.cpu.usage || 0)"
                  >
                    <template v-slot="{ value }">
                      <strong>{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>

                  <v-divider class="my-3"></v-divider>

                  <!-- Velocidades -->
                  <v-layout row wrap v-if="serverStatus.cpu.currentSpeedGHz">
                    <v-flex xs12 sm4>
                      <div class="text-xs-center pa-2">
                        <div class="caption grey--text">Velocidade Atual</div>
                        <div class="title font-weight-bold" style="color: #4CAF50;">
                          {{ serverStatus.cpu.currentSpeedGHz }} GHz
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <div class="text-xs-center pa-2">
                        <div class="caption grey--text">Base</div>
                        <div class="title font-weight-bold" style="color: #7e2985;">
                          {{ serverStatus.cpu.baseSpeedGHz || serverStatus.cpu.speedGHz }} GHz
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <div class="text-xs-center pa-2" v-if="serverStatus.cpu.maxSpeedGHz && serverStatus.cpu.maxSpeedGHz !== serverStatus.cpu.baseSpeedGHz">
                        <div class="caption grey--text">Máxima</div>
                        <div class="title font-weight-bold" style="color: #FF9800;">
                          {{ serverStatus.cpu.maxSpeedGHz }} GHz
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-divider class="my-3"></v-divider>

                  <!-- Informações da CPU -->
                  <v-layout row wrap>
                    <v-flex xs6 sm3>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Núcleos</div>
                        <div class="cpu-info-value">{{ serverStatus.cpu.physicalCores || serverStatus.cpu.cores || 'N/A' }}</div>
                      </div>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Processadores lógicos</div>
                        <div class="cpu-info-value">{{ serverStatus.cpu.logicalCores || serverStatus.cpu.cores || 'N/A' }}</div>
                      </div>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Processos</div>
                        <div class="cpu-info-value">{{ formatNumber(serverStatus.process.processes) || '0' }}</div>
                      </div>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Threads</div>
                        <div class="cpu-info-value">{{ formatNumber(serverStatus.process.threads) || '0' }}</div>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-divider class="my-2"></v-divider>

                  <!-- Handles e Modelo -->
                  <v-layout row wrap>
                    <v-flex xs12 sm6 v-if="serverStatus.process && serverStatus.process.handles > 0">
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Handles</div>
                        <div class="cpu-info-value">{{ formatNumber(serverStatus.process.handles) || '0' }}</div>
                      </div>
                    </v-flex>
                    <v-flex xs12 :sm6="serverStatus.process && serverStatus.process.handles > 0" :sm12="!serverStatus.process || serverStatus.process.handles === 0">
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Modelo</div>
                        <div class="cpu-info-value" style="font-size: 12px;">{{ serverStatus.cpu.model || 'N/A' }}</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
                <div v-else class="text-xs-center pa-3">
                  <div class="subheading grey--text">Carregando...</div>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 md6>
            <v-card class="pa-3 ma-2" elevation="3">
              <v-card-title class="title pb-2" style="color: #7e2985;">
                <v-icon left color="#7e2985">storage</v-icon>
                Memória
              </v-card-title>
              <v-card-text>
                <div v-if="serverStatus.memory">
                  <div class="text-xs-center mb-2">
                    <div class="display-2 font-weight-bold" :style="{ color: getMemoryColor(parseFloat(serverStatus.memory.usagePercent) || 0) }">
                      {{ serverStatus.memory.usagePercent || '0.0' }}%
                    </div>
                    <div class="body-2 grey--text">Uso da Memória</div>
                  </div>
                  <v-progress-linear
                    :value="parseFloat(serverStatus.memory.usagePercent) || 0"
                    height="25"
                    :color="getMemoryColor(parseFloat(serverStatus.memory.usagePercent) || 0)"
                  >
                    <template v-slot="{ value }">
                      <strong>{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                  
                  <v-divider class="my-3"></v-divider>

                  <!-- Informações da Memória -->
                  <v-layout row wrap>
                    <v-flex xs4>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Total</div>
                        <div class="cpu-info-value">{{ serverStatus.memory.totalGB || 'N/A' }}<span style="font-size: 16px; color: #666;"> GB</span></div>
                      </div>
                    </v-flex>
                    <v-flex xs4>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Em Uso</div>
                        <div class="cpu-info-value">{{ serverStatus.memory.usedGB || 'N/A' }}<span style="font-size: 16px; color: #666;"> GB</span></div>
                      </div>
                    </v-flex>
                    <v-flex xs4>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Livre</div>
                        <div class="cpu-info-value">{{ serverStatus.memory.freeGB || 'N/A' }}<span style="font-size: 16px; color: #666;"> GB</span></div>
                      </div>
                    </v-flex>
                  </v-layout>

                  <!-- Informações Detalhadas (Linux) -->
                  <v-layout row wrap class="mt-3" v-if="serverStatus.memory.cacheGB && parseFloat(serverStatus.memory.cacheGB) > 0">
                    <v-flex xs4>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Cache</div>
                        <div class="cpu-info-value">{{ serverStatus.memory.cacheGB || '0.00' }}<span style="font-size: 16px; color: #666;"> GB</span></div>
                      </div>
                    </v-flex>
                    <v-flex xs4>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Buffers</div>
                        <div class="cpu-info-value">{{ serverStatus.memory.bufferGB || '0.00' }}<span style="font-size: 16px; color: #666;"> GB</span></div>
                      </div>
                    </v-flex>
                    <v-flex xs4>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Apps</div>
                        <div class="cpu-info-value">{{ serverStatus.memory.appUsedGB || serverStatus.memory.usedGB || 'N/A' }}<span style="font-size: 16px; color: #666;"> GB</span></div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
                <div v-else class="text-xs-center pa-3">
                  <div class="subheading grey--text">Carregando...</div>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- Armazenamento -->
        <v-layout row wrap class="mt-3">
          <v-flex xs12>
            <v-card class="pa-3 ma-2" elevation="3">
              <v-card-title class="title pb-2" style="color: #7e2985;">
                <v-icon left color="#7e2985">storage</v-icon>
                Armazenamento
              </v-card-title>
              <v-card-text>
                <div v-if="serverStatus.disk && serverStatus.disk.total">
                  <!-- Resumo Geral -->
                  <div class="text-xs-center mb-4">
                    <div class="display-2 font-weight-bold" :style="{ color: getDiskColor(parseFloat(serverStatus.disk.total.usagePercent) || 0) }">
                      {{ serverStatus.disk.total.usagePercent || '0.0' }}%
                    </div>
                    <div class="body-2 grey--text">Uso Total do Armazenamento</div>
                  </div>
                  <v-progress-linear
                    :value="parseFloat(serverStatus.disk.total.usagePercent) || 0"
                    height="25"
                    :color="getDiskColor(parseFloat(serverStatus.disk.total.usagePercent) || 0)"
                  >
                    <template v-slot="{ value }">
                      <strong>{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>

                  <v-divider class="my-3"></v-divider>

                  <!-- Informações Gerais -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs4>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Total</div>
                        <div class="cpu-info-value">{{ serverStatus.disk.total.totalGB || 'N/A' }}<span style="font-size: 16px; color: #666;"> GB</span></div>
                      </div>
                    </v-flex>
                    <v-flex xs4>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Em Uso</div>
                        <div class="cpu-info-value">{{ serverStatus.disk.total.usedGB || 'N/A' }}<span style="font-size: 16px; color: #666;"> GB</span></div>
                      </div>
                    </v-flex>
                    <v-flex xs4>
                      <div class="cpu-info-item">
                        <div class="cpu-info-label">Livre</div>
                        <div class="cpu-info-value">{{ serverStatus.disk.total.freeGB || 'N/A' }}<span style="font-size: 16px; color: #666;"> GB</span></div>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-divider class="my-3"></v-divider>

                  <!-- Lista de Discos -->
                  <div class="mb-3">
                    <div class="body-2 font-weight-bold mb-3">Discos Instalados:</div>
                    <v-data-table
                      :headers="diskHeaders"
                      :items="serverStatus.disk.disks || []"
                      hide-actions
                      class="elevation-0"
                      no-data-text="Nenhum disco encontrado"
                      dense
                      flat
                      :sort-by="['usagePercent']"
                      :sort-desc="[true]"
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-left">{{ props.item.mount }}</td>
                        <td class="text-xs-center">{{ props.item.type }}</td>
                        <td class="text-xs-center">{{ props.item.totalGB }} GB</td>
                        <td class="text-xs-center">{{ props.item.usedGB }} GB</td>
                        <td class="text-xs-center">{{ props.item.freeGB }} GB</td>
                        <td class="text-xs-center">
                          <span :style="{ color: getDiskColor(parseFloat(props.item.usagePercent)), fontWeight: 'bold' }">
                            {{ props.item.usagePercent }}%
                          </span>
                        </td>
                        <td class="text-xs-center" style="font-size: 12px;">{{ props.item.model }}</td>
                      </template>
                    </v-data-table>
                  </div>
                </div>
                <div v-else class="text-xs-center pa-3">
                  <div class="subheading grey--text">Carregando...</div>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- Load Average (apenas para Linux/Mac) -->
        <v-layout row wrap class="mt-3" v-if="serverStatus.platform && serverStatus.platform !== 'win32'">
          <v-flex xs12>
            <v-card class="pa-3 ma-2" elevation="3">
              <v-card-title class="title pb-2" style="color: #7e2985;">
                <v-icon left color="#7e2985">trending_up</v-icon>
                Load Average
              </v-card-title>
              <v-card-text>
                <v-layout row wrap v-if="serverStatus.loadAverage">
                  <v-flex xs12 sm4>
                    <div class="text-xs-center pa-3">
                      <div class="caption grey--text">1 minuto</div>
                      <div class="display-1 font-weight-bold" style="color: #7e2985;">
                        {{ serverStatus.loadAverage[0] !== undefined ? serverStatus.loadAverage[0].toFixed(2) : '0.00' }}
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <div class="text-xs-center pa-3">
                      <div class="caption grey--text">5 minutos</div>
                      <div class="display-1 font-weight-bold" style="color: #7e2985;">
                        {{ serverStatus.loadAverage[1] !== undefined ? serverStatus.loadAverage[1].toFixed(2) : '0.00' }}
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <div class="text-xs-center pa-3">
                      <div class="caption grey--text">15 minutos</div>
                      <div class="display-1 font-weight-bold" style="color: #7e2985;">
                        {{ serverStatus.loadAverage[2] !== undefined ? serverStatus.loadAverage[2].toFixed(2) : '0.00' }}
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
                <div v-else class="text-xs-center pa-3">
                  <div class="subheading grey--text">Carregando...</div>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
                    </v-layout>

                    <!-- Lista de Processos -->
                    <v-layout row wrap class="mt-3">
                      <v-flex xs12>
                        <v-card class="pa-3 ma-2" elevation="3">
                          <v-card-title class="title pb-2" style="color: #7e2985;">
                            <v-icon left color="#7e2985">list</v-icon>
                            Top 10 Processos (Por CPU)
                          </v-card-title>
                          <v-card-text>
                            <v-data-table
                              :headers="processHeaders"
                              :items="serverStatus.process && serverStatus.process.list ? serverStatus.process.list : []"
                              hide-actions
                              class="elevation-0"
                              no-data-text="Nenhum processo encontrado"
                              dense
                              flat
                              :sort-by="['cpu']"
                              :sort-desc="[true]"
                            >
                              <template v-slot:items="props">
                                <td class="text-xs-center">{{ props.item.name }}</td>
                                <td class="text-xs-center">{{ props.item.pid }}</td>
                                <td class="text-xs-center">
                                  <span :style="{ color: getCpuColor(props.item.cpu), fontWeight: 'bold' }">
                                    {{ props.item.cpu.toFixed(2) }}%
                                  </span>
                                </td>
                                <td class="text-xs-center">{{ props.item.memory.toFixed(2) }} MB</td>
                              </template>
                            </v-data-table>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-tab-item>

                <!-- Aba 2: Rede -->
                <v-tab-item>
                  <v-card flat class="pa-3">
                    <div v-if="serverStatus.network">
                  <!-- Informações de Interface e IP -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm6 md3>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title class="font-weight-bold">Nome do adaptador:</v-list-tile-title>
                            <v-list-tile-sub-title>{{ serverStatus.network.interface || 'N/A' }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title class="font-weight-bold">SSID:</v-list-tile-title>
                            <v-list-tile-sub-title>{{ serverStatus.network.ssid || 'N/A' }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title class="font-weight-bold">Tipo de conexão:</v-list-tile-title>
                            <v-list-tile-sub-title>{{ serverStatus.network.type || 'N/A' }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title class="font-weight-bold">Endereço IPv4:</v-list-tile-title>
                            <v-list-tile-sub-title>{{ serverStatus.network.ip || 'N/A' }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>

                  <!-- IPv6 (se disponível) -->
                  <v-layout row wrap class="mb-2" v-if="serverStatus.network.ipv6 && serverStatus.network.ipv6 !== 'N/A'">
                    <v-flex xs12>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title class="font-weight-bold">Endereço IPv6:</v-list-tile-title>
                            <v-list-tile-sub-title style="font-size: 12px;">{{ serverStatus.network.ipv6 }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>

                  <v-divider class="my-3"></v-divider>

                  <!-- Download e Upload -->
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <div class="text-xs-center pa-2">
                        <div class="display-2 font-weight-bold mb-2" style="color: #4CAF50;">
                          <v-icon large color="#4CAF50">arrow_downward</v-icon>
                        </div>
                        <div class="caption grey--text mb-2">Download</div>
                        <div class="display-1 font-weight-bold" style="color: #4CAF50;">
                          {{ serverStatus.network.downloadSpeedMbps || '0.00' }} Mbps
                        </div>
                        <div class="caption grey--text mt-1">Velocidade Atual</div>
                        <v-divider class="my-3"></v-divider>
                        <div class="title font-weight-bold" style="color: #666;">
                          {{ serverStatus.network.totalDownloadedGB || '0.00' }} GB
                        </div>
                        <div class="caption grey--text">Total Recebido</div>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <div class="text-xs-center pa-2">
                        <div class="display-2 font-weight-bold mb-2" style="color: #FF9800;">
                          <v-icon large color="#FF9800">arrow_upward</v-icon>
                        </div>
                        <div class="caption grey--text mb-2">Upload</div>
                        <div class="display-1 font-weight-bold" style="color: #FF9800;">
                          {{ serverStatus.network.uploadSpeedMbps || '0.00' }} Mbps
                        </div>
                        <div class="caption grey--text mt-1">Velocidade Atual</div>
                        <v-divider class="my-3"></v-divider>
                        <div class="title font-weight-bold" style="color: #666;">
                          {{ serverStatus.network.totalUploadedGB || '0.00' }} GB
                        </div>
                        <div class="caption grey--text">Total Enviado</div>
                      </div>
                    </v-flex>
                  </v-layout>
                    </div>
                    <div v-else class="text-xs-center pa-3">
                      <div class="subheading grey--text">Carregando...</div>
                    </div>
                  </v-card>
                </v-tab-item>

                <!-- Aba 3: PM2 -->
                <v-tab-item>
                  <v-card flat class="pa-3">
                    <div v-if="serverStatus.pm2">
                      <!-- Status Geral do PM2 -->
                      <v-layout row wrap class="mb-3">
                        <v-flex xs12>
                          <v-card class="pa-3 ma-2" elevation="3">
                            <v-card-title class="title pb-2" style="color: #7e2985;">
                              <v-icon left color="#7e2985">settings</v-icon>
                              Status do PM2
                            </v-card-title>
                            <v-card-text>
                              <v-layout row wrap v-if="serverStatus.pm2.available">
                                <v-flex xs12 sm3>
                                  <div class="text-xs-center pa-2">
                                    <div class="display-2 font-weight-bold" style="color: #4CAF50;">
                                      {{ serverStatus.pm2.total || 0 }}
                                    </div>
                                    <div class="caption grey--text">Total</div>
                                  </div>
                                </v-flex>
                                <v-flex xs12 sm3>
                                  <div class="text-xs-center pa-2">
                                    <div class="display-2 font-weight-bold" style="color: #4CAF50;">
                                      {{ serverStatus.pm2.running || 0 }}
                                    </div>
                                    <div class="caption grey--text">Executando</div>
                                  </div>
                                </v-flex>
                                <v-flex xs12 sm3>
                                  <div class="text-xs-center pa-2">
                                    <div class="display-2 font-weight-bold" style="color: #FF9800;">
                                      {{ serverStatus.pm2.stopped || 0 }}
                                    </div>
                                    <div class="caption grey--text">Parados</div>
                                  </div>
                                </v-flex>
                                <v-flex xs12 sm3>
                                  <div class="text-xs-center pa-2">
                                    <div class="display-2 font-weight-bold" style="color: #F44336;">
                                      {{ serverStatus.pm2.errored || 0 }}
                                    </div>
                                    <div class="caption grey--text">Com Erro</div>
                                  </div>
                                </v-flex>
                              </v-layout>
                              <div v-else class="text-xs-center pa-3">
                                <v-alert type="warning" :value="true">
                                  PM2 não está disponível no sistema: {{ serverStatus.pm2.error || 'Erro desconhecido' }}
                                </v-alert>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <!-- Comandos Avançados PM2 -->
                      <v-layout row wrap class="mb-3" v-if="serverStatus.pm2.available">
                        <v-flex xs12>
                          <v-card class="pa-3 ma-2" elevation="3">
                            <v-card-title class="title pb-2" style="color: #7e2985;">
                              <v-icon left color="#7e2985">settings_applications</v-icon>
                              Comandos Avançados PM2
                            </v-card-title>
                            <v-card-text>
                              <v-layout row wrap>
                                <!-- Comandos de Sistema -->
                                <!-- <v-flex xs12 sm6 md3>
                                  <v-btn 
                                    color="primary" 
                                    block 
                                    @click="executePM2Command('save')"
                                    :loading="pm2CommandLoading.save"
                                    class="mb-2"
                                  >
                                    <v-icon left>save</v-icon>
                                    Salvar
                                  </v-btn>
                                </v-flex> -->
                                <v-flex xs12 sm6 md4>
                                  <v-btn 
                                    color="success" 
                                    block 
                                    @click="executePM2Command('resurrect')"
                                    :loading="pm2CommandLoading.resurrect"
                                    class="mb-2"
                                  >
                                    <v-icon left>restore</v-icon>
                                    Restaurar
                                  </v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                  <v-btn 
                                    color="warning" 
                                    block 
                                    @click="executePM2Command('flush')"
                                    :loading="pm2CommandLoading.flush"
                                    class="mb-2"
                                  >
                                    <v-icon left>clear_all</v-icon>
                                    Limpar Logs
                                  </v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                  <v-btn 
                                    color="info" 
                                    block 
                                    @click="showLogsModal()"
                                    class="mb-2"
                                  >
                                    <v-icon left>description</v-icon>
                                    Ver Logs
                                  </v-btn>
                                </v-flex>
                              </v-layout>

                              <v-divider class="my-3"></v-divider>

                              <!-- Comandos em Lote -->
                              <div class="mb-3">
                                <div class="subheading font-weight-bold mb-2">Ações em Lote:</div>
                                <v-layout row wrap>
                                  <v-flex xs12 sm6 md6>
                                    <v-btn 
                                      color="success" 
                                      block 
                                      @click="executePM2Command('restartAll')"
                                      :loading="pm2CommandLoading.restartAll"
                                      class="mb-2"
                                    >
                                      <v-icon left>refresh</v-icon>
                                      Reiniciar Todos
                                    </v-btn>
                                  </v-flex>
                                  <!-- <v-flex xs12 sm6 md4>
                                    <v-btn 
                                      color="warning" 
                                      block 
                                      @click="executePM2Command('stopAll')"
                                      :loading="pm2CommandLoading.stopAll"
                                      class="mb-2"
                                    >
                                      <v-icon left>pause_circle_filled</v-icon>
                                      Parar Todos
                                    </v-btn>
                                  </v-flex> -->
                                  <v-flex xs12 sm6 md6>
                                    <v-btn 
                                      color="info" 
                                      block 
                                      @click="executePM2Command('reload')"
                                      :loading="pm2CommandLoading.reload"
                                      class="mb-2"
                                    >
                                      <v-icon left>cached</v-icon>
                                      Recarregar Todos
                                    </v-btn>
                                  </v-flex>
                                  <!-- <v-flex xs12 sm6 md3>
                                    <v-btn 
                                      color="error" 
                                      block 
                                      @click="confirmDeleteAll()"
                                      :loading="pm2CommandLoading.deleteAll"
                                      class="mb-2"
                                    >
                                      <v-icon left>delete_sweep</v-icon>
                                      Deletar Todos
                                    </v-btn>
                                  </v-flex> -->
                                </v-layout>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <!-- Lista de Processos PM2 -->
                      <v-layout row wrap v-if="serverStatus.pm2.available && serverStatus.pm2.processes">
                        <v-flex xs12>
                          <v-card class="pa-3 ma-2" elevation="3">
                            <v-card-title class="title pb-2" style="color: #7e2985;">
                              <v-icon left color="#7e2985">list</v-icon>
                              Processos Gerenciados pelo PM2
                            </v-card-title>
                            <v-card-text>
                              <v-data-table
                                :headers="pm2Headers"
                                :items="serverStatus.pm2.processes"
                                hide-actions
                                class="elevation-0"
                                no-data-text="Nenhum processo PM2 encontrado"
                                dense
                                flat
                                :sort-by="['name']"
                                :sort-desc="[false]"
                              >
                                <template v-slot:items="props">
                                  <td class="text-xs-center">{{ props.item.id }}</td>
                                  <td class="text-xs-center">{{ props.item.name }}</td>
                                  <td class="text-xs-center">
                                    <v-chip 
                                      :color="getPM2StatusColor(props.item.status)" 
                                      text-color="white" 
                                      small
                                    >
                                      {{ props.item.status }}
                                    </v-chip>
                                  </td>
                                  <td class="text-xs-center">{{ props.item.cpu.toFixed(2) }}%</td>
                                  <td class="text-xs-center">{{ props.item.memoryMB }} MB</td>
                                  <td class="text-xs-center">{{ props.item.uptimeFormatted }}</td>
                                  <td class="text-xs-center">{{ props.item.restartCount }}</td>
                                  <td class="text-xs-center">
                                    <v-btn-group>
                                      <!-- <v-btn 
                                        v-if="props.item.status === 'stopped'"
                                        color="success" 
                                        small 
                                        @click="controlPM2Process(props.item.id, 'start')"
                                        :loading="pm2ActionLoading[props.item.id]"
                                      >
                                        <v-icon small>play_arrow</v-icon>
                                      </v-btn>
                                      <v-btn 
                                        v-if="props.item.status === 'online'"
                                        color="warning" 
                                        small 
                                        @click="controlPM2Process(props.item.id, 'stop')"
                                        :loading="pm2ActionLoading[props.item.id]"
                                      >
                                        <v-icon small>pause</v-icon>
                                      </v-btn> -->
                                      <v-btn 
                                        v-if="props.item.status === 'online'"
                                        color="info" 
                                        small 
                                        @click="controlPM2Process(props.item.id, 'restart')"
                                        :loading="pm2ActionLoading[props.item.id]"
                                      >
                                        <v-icon small>refresh</v-icon>
                                      </v-btn>
                                      <v-btn 
                                        color="primary" 
                                        small 
                                        @click="showProcessLogs(props.item.id, props.item.name)"
                                      >
                                        <v-icon small>description</v-icon>
                                      </v-btn>
                                      <!-- <v-btn 
                                        color="error" 
                                        small 
                                        @click="controlPM2Process(props.item.id, 'delete')"
                                        :loading="pm2ActionLoading[props.item.id]"
                                      >
                                        <v-icon small>delete</v-icon>
                                      </v-btn> -->
                                    </v-btn-group>
                                  </td>
                                </template>
                              </v-data-table>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div v-else class="text-xs-center pa-3">
                      <div class="subheading grey--text">Carregando informações do PM2...</div>
                    </div>
                  </v-card>
                </v-tab-item>

                <!-- Modal de Logs PM2 -->
                <v-dialog v-model="logsModal" max-width="90%" persistent>
                  <v-card>
                    <v-card-title class="headline" style="color: #7e2985;">
                      <v-icon left color="#7e2985">description</v-icon>
                      Logs do PM2 - {{ selectedProcessName || 'Todos os Processos' }}
                    </v-card-title>
                    <v-card-text>
                      <v-layout row wrap class="mb-3">
                        <v-flex xs12 sm6>
                          <v-select
                            v-model="selectedProcessId"
                            :items="processOptions"
                            label="Selecionar Processo"
                            @change="loadLogs"
                            clearable
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-select
                            v-model="logLines"
                            :items="logLinesOptions"
                            label="Linhas"
                            @change="loadLogs"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-btn 
                            color="primary" 
                            @click="loadLogs"
                            :loading="logsLoading"
                            block
                          >
                            <v-icon left>refresh</v-icon>
                            Atualizar
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      
                      <v-divider class="mb-3"></v-divider>
                      
                      <div v-if="logsLoading" class="text-xs-center pa-4">
                        <v-progress-circular indeterminate color="#7e2985"></v-progress-circular>
                        <div class="mt-2">Carregando logs...</div>
                      </div>
                      
                      <div v-else-if="currentLogs" class="logs-container">
                        <pre class="logs-content">{{ currentLogs }}</pre>
                      </div>
                      
                      <div v-else class="text-xs-center pa-4 grey--text">
                        Nenhum log disponível
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="grey" text @click="closeLogsModal">
                        Fechar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Modal de Confirmação -->
                <v-dialog v-model="confirmModal" max-width="400">
                  <v-card>
                    <v-card-title class="headline" style="color: #F44336;">
                      <v-icon left color="#F44336">warning</v-icon>
                      Confirmar Ação
                    </v-card-title>
                    <v-card-text>
                      {{ confirmMessage }}
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="grey" text @click="confirmModal = false">
                        Cancelar
                      </v-btn>
                      <v-btn color="error" @click="executeConfirmedAction">
                        Confirmar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Aba 4: Endpoint -->
                <v-tab-item>
                  <v-card flat class="pa-3">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card class="pa-3 ma-2" elevation="3">
                          <v-card-title class="title pb-2" style="color: #7e2985;">
                            <v-icon left color="#7e2985">link</v-icon>
                            Endpoint da API de Status
                          </v-card-title>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <div class="mb-3">
                                  <div class="body-2 font-weight-bold mb-2">URL do Endpoint:</div>
                                  <v-text-field
                                    :value="currentEndpoint"
                                    readonly
                                    outlined
                                    dense
                                    append-icon="content_copy"
                                    @click:append="copyToClipboard(currentEndpoint)"
                                  ></v-text-field>
                                </div>

                                <v-divider class="my-3"></v-divider>

                                <div class="mb-3">
                                  <div class="body-2 font-weight-bold mb-2">Método:</div>
                                  <v-chip color="#7e2985" text-color="white" small>GET</v-chip>
                                </div>

                                <v-divider class="my-3"></v-divider>

                                <div class="mb-3">
                                  <div class="body-2 font-weight-bold mb-2">Exemplo de Resposta (JSON):</div>
                                  <pre class="api-response-example">{{ exampleResponse }}</pre>
                                </div>

                                <v-divider class="my-3"></v-divider>

                                <div class="mb-3">
                                  <div class="body-2 font-weight-bold mb-2">Testar Endpoint:</div>
                                  <v-btn color="#7e2985" dark @click="testEndpoint">
                                    <v-icon left>play_arrow</v-icon>
                                    Executar Requisição
                                  </v-btn>
                                </div>

                                <div v-if="endpointResponse" class="mt-3">
                                  <v-alert :type="endpointResponseType" :value="true">
                                    {{ endpointResponseMessage }}
                                  </v-alert>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- Atualização Automática -->
        <v-layout row wrap class="mt-3">
          <v-flex xs12 class="text-xs-center">
            <v-card class="pa-4 ma-2" elevation="3">
              <v-card-text>
                <v-switch
                  v-model="autoRefresh"
                  label="Atualização Automática"
                  color="#7e2985"
                  @change="toggleAutoRefresh"
                  class="d-inline-block mr-4"
                ></v-switch>
                <v-select
                  v-if="autoRefresh"
                  v-model="refreshInterval"
                  :items="intervalOptions"
                  label="Intervalo de Atualização"
                  @change="resetAutoRefresh"
                  style="max-width: 200px; display: inline-block;"
                ></v-select>
                <v-btn
                  color="#7e2985"
                  dark
                  @click="fetchServerStatus"
                  class="ml-4"
                >
                  <v-icon left>refresh</v-icon>
                  Atualizar Agora
                </v-btn>
                <div class="mt-2 grey--text">
                  Última atualização: {{ lastUpdate }}
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import { baseApiUrl, userKey } from '@/global';

export default {
  name: 'ServerMonitor',
  data() {
    return {
      serverStatus: {},
      loading: true,
      error: false,
      errorMessage: '',
      autoRefresh: false,
      refreshInterval: 5000,
      intervalId: null,
      lastUpdate: '',
      activeTab: 0,
      intervalOptions: [
        { text: '1 segundo', value: 1000 },
        { text: '2 segundos', value: 2000 },
        { text: '3 segundos', value: 3000 },
        { text: '5 segundos', value: 5000 },
        { text: '10 segundos', value: 10000 },
        { text: '30 segundos', value: 30000 },
        { text: '1 minuto', value: 60000 },
      ],
      processHeaders: [
        { text: 'Nome do Processo', value: 'name', align: 'center', sortable: true },
        { text: 'PID', value: 'pid', align: 'center', sortable: true },
        { text: 'CPU (%)', value: 'cpu', align: 'center', sortable: true },
        { text: 'Memória', value: 'memory', align: 'center', sortable: true }
      ],
      diskHeaders: [
        { text: 'Ponto de Montagem', value: 'mount', align: 'left', sortable: true },
        { text: 'Tipo', value: 'type', align: 'center', sortable: true },
        { text: 'Total', value: 'totalGB', align: 'center', sortable: true },
        { text: 'Usado', value: 'usedGB', align: 'center', sortable: true },
        { text: 'Livre', value: 'freeGB', align: 'center', sortable: true },
        { text: 'Uso (%)', value: 'usagePercent', align: 'center', sortable: true },
        { text: 'Modelo', value: 'model', align: 'center', sortable: true }
      ],
      pm2Headers: [
        { text: 'ID', value: 'id', align: 'center', sortable: true },
        { text: 'Nome', value: 'name', align: 'center', sortable: true },
        { text: 'Status', value: 'status', align: 'center', sortable: true },
        { text: 'CPU (%)', value: 'cpu', align: 'center', sortable: true },
        { text: 'Memória', value: 'memoryMB', align: 'center', sortable: true },
        { text: 'Uptime', value: 'uptimeFormatted', align: 'center', sortable: true },
        { text: 'Restarts', value: 'restartCount', align: 'center', sortable: true },
        { text: 'Ações', value: 'actions', align: 'center', sortable: false }
      ],
      pm2ActionLoading: {},
      pm2CommandLoading: {
        save: false,
        resurrect: false,
        flush: false,
        restartAll: false,
        stopAll: false,
        reload: false,
        deleteAll: false
      },
      logsModal: false,
      logsLoading: false,
      currentLogs: '',
      selectedProcessId: '',
      selectedProcessName: '',
      logLines: 100,
      logLinesOptions: [
        { text: '50 linhas', value: 50 },
        { text: '100 linhas', value: 100 },
        { text: '200 linhas', value: 200 },
        { text: '500 linhas', value: 500 },
        { text: '1000 linhas', value: 1000 }
      ],
      confirmModal: false,
      confirmMessage: '',
      pendingAction: null,
      apiEndpoints: {
        processing: `${baseApiUrl}ServerStatuses/processing`,
        network: `${baseApiUrl}ServerStatuses/network`,
        pm2: `${baseApiUrl}ServerStatuses/pm2`,
        full: `${baseApiUrl}ServerStatuses/status`
      },
      endpointResponse: false,
      endpointResponseType: 'success',
      endpointResponseMessage: '',
      exampleResponse: JSON.stringify({
        hostname: "DESKTOP-EXAMPLE",
        platform: "win32",
        cpu: { usage: 45, cores: 8, currentSpeedGHz: "3.20" },
        memory: { 
          totalGB: "16.00", 
          usedGB: "8.50", 
          freeGB: "7.50",
          usagePercent: "53.12",
          cacheGB: "2.30",
          bufferGB: "0.50",
          appUsedGB: "5.70",
          appUsagePercent: "35.63"
        },
        network: { interface: "Wi-Fi", ip: "192.168.1.100", downloadSpeedMbps: "0.50" },
        process: { processes: 230, threads: 3500, list: [{ name: "chrome.exe", pid: 1234, cpu: 15.5, memory: 512 }] },
        disk: { 
          total: { totalGB: "500.00", usedGB: "250.00", freeGB: "250.00", usagePercent: "50.00" },
          disks: [{ mount: "C:", type: "NTFS", totalGB: "500.00", usedGB: "250.00", freeGB: "250.00", usagePercent: "50.00", model: "Samsung SSD 970 EVO" }]
        },
        pm2: {
          available: true,
          total: 3,
          running: 2,
          stopped: 1,
          errored: 0,
          processes: [
            { id: 0, name: "api-server", status: "online", cpu: 15.5, memoryMB: "128.50", uptimeFormatted: "2d 5h 30m", restartCount: 0 },
            { id: 1, name: "worker", status: "online", cpu: 8.2, memoryMB: "64.20", uptimeFormatted: "1d 12h 15m", restartCount: 1 },
            { id: 2, name: "scheduler", status: "stopped", cpu: 0, memoryMB: "0.00", uptimeFormatted: "0s", restartCount: 0 }
          ]
        }
      }, null, 2)
    };
  },
  mounted() {
    this.fetchServerInfo();
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  computed: {
    currentEndpoint() {
      switch (this.activeTab) {
        case 0: // Processamento
          return this.apiEndpoints.processing;
        case 1: // Rede
          return this.apiEndpoints.network;
        case 2: // PM2
          return this.apiEndpoints.pm2;
        case 3: // Endpoint
          return this.apiEndpoints.full;
        default:
          return this.apiEndpoints.full;
      }
    },
    processOptions() {
      if (!this.serverStatus.pm2 || !this.serverStatus.pm2.processes) {
        return [{ text: 'Todos os processos', value: '' }];
      }
      
      const options = [{ text: 'Todos os processos', value: '' }];
      this.serverStatus.pm2.processes.forEach(process => {
        options.push({
          text: `${process.name} (ID: ${process.id})`,
          value: process.id.toString()
        });
      });
      return options;
    }
  },
  watch: {
    activeTab(newTab) {
      // Para o auto-refresh atual
      this.stopAutoRefresh();
      
      // Inicia novo auto-refresh se estiver ativo
      if (this.autoRefresh) {
        this.startAutoRefresh();
      }
    }
  },
  methods: {
    async fetchServerInfo() {
      this.loading = true;
      this.error = false;
      try {
        // Carrega informações básicas do servidor (hostname, platform, etc)
        const response = await axios.get(this.apiEndpoints.full);
        this.serverStatus = response.data;
        this.lastUpdate = new Date().toLocaleString('pt-BR');
        
        // Inicia o auto-refresh se estiver ativo
        if (this.autoRefresh) {
          this.startAutoRefresh();
        }
      } catch (err) {
        this.error = true;
        this.errorMessage = 'Erro ao carregar informações do servidor. Verifique se o backend está rodando em http://localhost:3002';
      } finally {
        this.loading = false;
      }
    },
    async fetchServerStatus() {
      this.loading = true;
      this.error = false;
      try {
        let endpoint;
        let response;
        
        // Escolhe o endpoint baseado na aba ativa
        switch (this.activeTab) {
          case 0: // Processamento
            endpoint = this.apiEndpoints.processing;
            response = await axios.get(endpoint);
            // Merge com dados existentes, mantendo informações do servidor
            this.serverStatus = { ...this.serverStatus, ...response.data };
            break;
          case 1: // Rede
            endpoint = this.apiEndpoints.network;
            response = await axios.get(endpoint);
            // Merge com dados existentes, mantendo informações do servidor
            this.serverStatus = { ...this.serverStatus, ...response.data };
            break;
          case 2: // PM2
            endpoint = this.apiEndpoints.pm2;
            response = await axios.get(endpoint);
            // Merge com dados existentes, mantendo informações do servidor
            this.serverStatus = { ...this.serverStatus, ...response.data };
            break;
          case 3: // Endpoint - não precisa fazer fetch
            this.loading = false;
            return;
          default:
            endpoint = this.apiEndpoints.full;
            response = await axios.get(endpoint);
            this.serverStatus = response.data;
        }
        
        this.lastUpdate = new Date().toLocaleString('pt-BR');
      } catch (err) {
        this.error = true;
        this.errorMessage = 'Erro ao carregar informações do servidor. Verifique se o backend está rodando em http://localhost:3002';
      } finally {
        this.loading = false;
      }
    },
    getCpuColor(usage) {
      if (usage < 50) return 'success';
      if (usage < 75) return 'warning';
      return 'error';
    },
    getMemoryColor(usage) {
      if (usage < 60) return 'success';
      if (usage < 80) return 'warning';
      return 'error';
    },
    getDiskColor(usage) {
      if (usage < 70) return 'success';
      if (usage < 85) return 'warning';
      return 'error';
    },
    getPM2StatusColor(status) {
      switch (status) {
        case 'online':
          return 'success';
        case 'stopped':
          return 'warning';
        case 'errored':
          return 'error';
        case 'stopping':
        case 'launching':
          return 'info';
        default:
          return 'grey';
      }
    },
    toggleAutoRefresh() {
      if (this.autoRefresh) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    },
    startAutoRefresh() {
      this.stopAutoRefresh();
      this.intervalId = setInterval(() => {
        this.fetchServerStatus();
      }, this.refreshInterval);
    },
    stopAutoRefresh() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    resetAutoRefresh() {
      if (this.autoRefresh) {
        this.startAutoRefresh();
      }
    },
    formatNumber(num) {
      if (!num && num !== 0) return null; // Retorna null se não houver valor
      if (num === 0) return '0'; // Retorna '0' string se for zero
      return num.toLocaleString('pt-BR');
    },
    copyToClipboard(text) {
      // Cria um elemento temporário para copiar o texto
      const el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      
      // Mostra feedback
      this.endpointResponse = true;
      this.endpointResponseType = 'success';
      this.endpointResponseMessage = 'URL copiada para a área de transferência!';
      
      setTimeout(() => {
        this.endpointResponse = false;
      }, 3000);
    },
    async testEndpoint() {
      this.endpointResponse = true;
      this.endpointResponseType = 'info';
      this.endpointResponseMessage = 'Executando requisição...';
      
      try {
        const startTime = Date.now();
        let endpoint;
        
        // Escolhe o endpoint baseado na aba ativa
        switch (this.activeTab) {
          case 0: // Processamento
            endpoint = this.apiEndpoints.processing;
            break;
          case 1: // Rede
            endpoint = this.apiEndpoints.network;
            break;
          case 2: // PM2
            endpoint = this.apiEndpoints.pm2;
            break;
          case 3: // Endpoint - testa o endpoint completo
            endpoint = this.apiEndpoints.full;
            break;
          default:
            endpoint = this.apiEndpoints.full;
        }
        
        const response = await axios.get(endpoint);
        const endTime = Date.now();
        const duration = endTime - startTime;
        
        this.endpointResponseType = 'success';
        this.endpointResponseMessage = `✓ Requisição bem-sucedida! Tempo de resposta: ${duration}ms`;
        
      } catch (error) {
        this.endpointResponseType = 'error';
        this.endpointResponseMessage = `✗ Erro na requisição: ${error.message}`;
      }
    },
    async controlPM2Process(processId, action) {
      // Marca o processo como carregando
      this.$set(this.pm2ActionLoading, processId, true);
      
      try {
        const response = await axios.post(`${baseApiUrl}ServerStatuses/pm2/control`, {
          processId: processId,
          action: action
        });
        
        if (response.data.success) {
          // Mostra mensagem de sucesso
          this.$toast.success(response.data.message);
          
          // Atualiza os dados do PM2 após um pequeno delay
          setTimeout(() => {
            this.fetchServerStatus();
          }, 1000);
        } else {
          this.$toast.error(response.data.message || 'Erro ao executar ação');
        }
      } catch (error) {
        console.error('Erro ao controlar processo PM2:', error);
        this.$toast.error(`Erro ao executar ${action}: ${error.message}`);
      } finally {
        // Remove o estado de carregando
        this.$set(this.pm2ActionLoading, processId, false);
      }
    },
    async executePM2Command(command) {
      // Marca o comando como carregando
      this.$set(this.pm2CommandLoading, command, true);
      
      try {
        const response = await axios.post(`${baseApiUrl}ServerStatuses/pm2/advanced`, {
          command: command
        });
        
        if (response.data.success) {
          this.$toast.success(response.data.message);
          
          // Atualiza os dados do PM2 após comandos que afetam o estado
          if (['save', 'resurrect', 'restartAll', 'stopAll', 'reload', 'deleteAll'].includes(command)) {
            setTimeout(() => {
              this.fetchServerStatus();
            }, 1000);
          }
        } else {
          this.$toast.error(response.data.message || 'Erro ao executar comando');
        }
      } catch (error) {
        console.error('Erro ao executar comando PM2:', error);
        this.$toast.error(`Erro ao executar comando ${command}: ${error.message}`);
      } finally {
        // Remove o estado de carregando
        this.$set(this.pm2CommandLoading, command, false);
      }
    },
    showLogsModal() {
      this.selectedProcessId = '';
      this.selectedProcessName = '';
      this.currentLogs = '';
      this.logsModal = true;
      this.loadLogs();
    },
    showProcessLogs(processId, processName) {
      this.selectedProcessId = processId.toString();
      this.selectedProcessName = processName;
      this.currentLogs = '';
      this.logsModal = true;
      this.loadLogs();
    },
    async loadLogs() {
      this.logsLoading = true;
      
      try {
        const params = new URLSearchParams();
        if (this.selectedProcessId) {
          params.append('processId', this.selectedProcessId);
        }
        params.append('lines', this.logLines);
        
        const response = await axios.get(`${baseApiUrl}ServerStatuses/pm2/logs?${params}`);
        
        if (response.data.success) {
          this.currentLogs = response.data.logs;
        } else {
          this.currentLogs = `Erro ao carregar logs: ${response.data.message}`;
        }
      } catch (error) {
        console.error('Erro ao carregar logs:', error);
        this.currentLogs = `Erro ao carregar logs: ${error.message}`;
      } finally {
        this.logsLoading = false;
      }
    },
    closeLogsModal() {
      this.logsModal = false;
      this.selectedProcessId = '';
      this.selectedProcessName = '';
      this.currentLogs = '';
    },
    confirmDeleteAll() {
      this.confirmMessage = 'Tem certeza que deseja deletar TODOS os processos PM2? Esta ação não pode ser desfeita.';
      this.pendingAction = () => this.executePM2Command('deleteAll');
      this.confirmModal = true;
    },
    executeConfirmedAction() {
      if (this.pendingAction) {
        this.pendingAction();
        this.pendingAction = null;
      }
      this.confirmModal = false;
    },
    async logout() {
      try {
        // Para o auto-refresh se estiver ativo
        this.stopAutoRefresh();
        
        // Chama o endpoint de logout
        const token = localStorage.getItem('accToken');
        if (token) {
          await axios.post(`${baseApiUrl}Accounts/logout?access_token=${token}`);
        }
        
        // Limpa todos os dados do localStorage
        localStorage.removeItem('accToken');
        localStorage.removeItem(userKey);
        localStorage.removeItem('userPermission');
        localStorage.removeItem('userName');
        localStorage.removeItem('user');
        localStorage.removeItem('userId');
        
        // Redireciona para a página de login
        this.$router.push({ path: '/login' });
        
      } catch (error) {
        console.error('Erro no logout:', error);
        // Mesmo com erro, limpa os dados locais e redireciona
        localStorage.removeItem('accToken');
        localStorage.removeItem(userKey);
        localStorage.removeItem('userPermission');
        localStorage.removeItem('userName');
        localStorage.removeItem('user');
        localStorage.removeItem('userId');
        
        this.$router.push({ path: '/login' });
      }
    }
  }
};
</script>

<style scoped>
.server-monitor {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.v-card {
  border-radius: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
}

.v-list__tile {
  padding-left: 0;
}

.v-list__tile__title {
  font-size: 14px;
}

.v-list__tile__sub-title {
  font-size: 16px;
  color: #333 !important;
}

/* Garante que os flex items tenham altura igual */
.v-flex {
  display: flex;
}

/* Estilos para processos e threads */
.process-item {
  text-align: center;
  padding: 10px 0;
}

.process-label {
  font-size: 14px;
  font-weight: 500;
  color: #666;
  margin-bottom: 8px;
}

.process-value {
  font-size: 32px;
  font-weight: bold;
  color: #7e2985;
  line-height: 1.2;
}

/* Estilos para informações da CPU */
.cpu-info-item {
  text-align: center;
  padding: 8px;
}

.cpu-info-label {
  font-size: 12px;
  font-weight: 500;
  color: #666;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.cpu-info-value {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  line-height: 1.2;
}

/* Estilos para exemplo de resposta da API */
.api-response-example {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  overflow-x: auto;
  max-height: 400px;
  overflow-y: auto;
}

/* Estilos customizados para as abas */
.custom-tabs-card {
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  box-shadow: 0 8px 32px rgba(126, 41, 133, 0.1);
}

.custom-tabs {
  background: linear-gradient(135deg, #7e2985 0%, #9c27b0 100%);
}

.custom-tab {
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.custom-tab:before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.custom-tab:hover:before {
  left: 100%;
}

.tab-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 16px;
  transition: all 0.3s ease;
}

.tab-icon {
  margin-bottom: 4px;
  transition: all 0.3s ease;
}

.tab-text {
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
}

/* Estilo para aba ativa */
.custom-tab.v-tab--active .tab-content {
  transform: translateY(-2px);
}

.custom-tab.v-tab--active .tab-icon {
  transform: scale(1.1);
  color: #ffffff;
}

.custom-tab.v-tab--active .tab-text {
  color: #ffffff;
  font-weight: 700;
}

/* Estilo para aba inativa */
.custom-tab:not(.v-tab--active) .tab-content {
  color: rgba(255, 255, 255, 0.8);
}

.custom-tab:not(.v-tab--active):hover .tab-content {
  color: rgba(255, 255, 255, 0.95);
  transform: translateY(-1px);
}

.custom-tab:not(.v-tab--active):hover .tab-icon {
  transform: scale(1.05);
}

/* Slider customizado */
.custom-tabs .v-tabs__slider {
  background: linear-gradient(90deg, #ffffff, #f8f9fa);
  height: 4px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Estilos para o botão de logout */
.logout-button {
  border-radius: 25px;
  text-transform: none;
  font-weight: 600;
  padding: 0 20px;
  transition: all 0.3s ease;
}

.logout-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(126, 41, 133, 0.3);
}

.logout-button .v-icon {
  margin-right: 8px;
}

/* Estilos para o modal de logs */
.logs-container {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f8f9fa;
}

.logs-content {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.4;
  margin: 0;
  padding: 12px;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #333;
  background-color: #f8f9fa;
}

/* Estilos para botões de comando PM2 */
.pm2-command-btn {
  margin: 2px;
  min-width: 120px;
}

/* Estilos para grupos de botões */
.v-btn-group .v-btn {
  margin: 0 1px;
}

/* Estilos responsivos para modais */
@media (max-width: 768px) {
  .logs-container {
    max-height: 300px;
  }
  
  .logs-content {
    font-size: 10px;
  }
}
</style>
